import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PricingEventError {
  screenshotError: boolean;
  dataError: boolean;
  errorDesc: string;
  timestamp: number;
}

export interface PricingEvent {
  slug: string;
  v1: string;
  v2: string;
  hasChanges: boolean;
  changes: string[];
  quarter: string;
  year: string;
  beforeUrl: string;
  afterUrl: string;
  beforePIUrl?: string;
  afterPIUrl?: string;
  plansChanged: boolean;
  priceIncreased: boolean;
  priceDecreased: boolean;
  priceAvailbilityChanged: boolean;
  introDiscount: boolean;
  displayChanged: boolean;
  logoUrl?: string;
  description?: string;
  category?: string;
  error?: PricingEventError;
  created_at?: string;
}

export type ApprovalFilterType = 'All' | 'Approved' | 'Not Approved' | 'Error';

interface EventsState {
  events: PricingEvent[];
  loading: boolean;
  error: string | null;
  approvalFilter: ApprovalFilterType;
}

const initialState: EventsState = {
  events: [],
  loading: false,
  error: null,
  approvalFilter: 'All'
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    setEvents: (state, action: PayloadAction<PricingEvent[]>) => {
      state.events = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setApprovalFilter: (state, action: PayloadAction<ApprovalFilterType>) => {
      state.approvalFilter = action.payload;
    },
    updateEventError: (state, action: PayloadAction<{
      slug: string,
      v1: string,
      v2: string,
      error: PricingEventError
    }>) => {
      const { slug, v1, v2, error } = action.payload;
      const eventIndex = state.events.findIndex(e =>
        e.slug === slug &&
        e.v1 === v1 &&
        e.v2 === v2
      );
      if (eventIndex !== -1) {
        const updatedEvent = {
          ...state.events[eventIndex],
          error: { ...error }
        };
        state.events = [
          ...state.events.slice(0, eventIndex),
          updatedEvent,
          ...state.events.slice(eventIndex + 1)
        ];
      }
    },
  },
});

export const {
  setEvents,
  setLoading,
  setError,
  updateEventError,
  setApprovalFilter
} = eventsSlice.actions;
export default eventsSlice.reducer;